import { TravelFileTypes, TravelFileTypesKeys } from './travelFileTypesOptions';

export type VoucherSourceTargetTypes = TravelFileTypes | 'supplier' | 'agent' | 'account';
export type VoucherSourceTargetTypesKeys = TravelFileTypesKeys | 'SUPPLIER' | 'AGENT' | 'ACCOUNT';
export const voucherSourceTargetTypesEnum: {
    [key in VoucherSourceTargetTypesKeys]: VoucherSourceTargetTypes;
} = {
    GROUP: 'group',
    CLIENT: 'client',
    SUPPLIER: 'supplier',
    AGENT: 'agent',
    ACCOUNT: 'account'
};
export const voucherSourceTargetTypesOptions = Object.values(
    voucherSourceTargetTypesEnum
) as VoucherSourceTargetTypes[];

export const voucherSourceTargetTypesToPreviewEnum = {
    [voucherSourceTargetTypesEnum.GROUP]: 'Group Travel File',
    [voucherSourceTargetTypesEnum.CLIENT]: 'Travel File',
    [voucherSourceTargetTypesEnum.SUPPLIER]: 'Supplier',
    [voucherSourceTargetTypesEnum.AGENT]: 'Agent',
    [voucherSourceTargetTypesEnum.ACCOUNT]: 'Account'
};

export const voucherSourceTargetTypesToShortEnum = {
    [voucherSourceTargetTypesEnum.GROUP]: 'GTF',
    [voucherSourceTargetTypesEnum.CLIENT]: 'TF',
    [voucherSourceTargetTypesEnum.SUPPLIER]: 'SP',
    [voucherSourceTargetTypesEnum.AGENT]: 'AG',
    [voucherSourceTargetTypesEnum.ACCOUNT]: 'AC'
};
